<template>
  <div class="page">
    <Header/>
    <div class="container d-flex justify-content-center">
  <div class="card shadow-lg rounded-3 py-3" style="border-radius:0; border:none">
    <div class="card-body p-1">
      <h1 class="card-title mb-3 text-dark text-uppercase" style="font-weight:700"><span
          style="color: #9ccc65">User Login</span></h1>

      <form @submit.prevent="submit">
        <div class="row">
          <div class="col">
            <div class="form-floating mb-3">
              <v-select
                  v-model="selectedUser"
                  :options="users"
                  :reduce="user => user"
                  label="username"
                  placeholder="Select a user"
              ></v-select>
            </div>
          <button :disabled="loading" type="submit" class="btn">
            Login
           </button>
        </div>
        </div>
      </form>
    </div>
  </div>
    </div>
    <p class="text-center mt-5">Powered By <a target="_blank" href="https://chrilantech.com">Lyt-Soft POS</a></p>
    <p class="text-center mt-5"><a target="_blank" href="https://tawk.to/LytSupport">Contact Support</a></p>
  </div>
</template>

<script>
import axios from "axios";
import { Storage } from "@/services/Storage";
import CryptoJS from "crypto-js";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import Header from "@/components/layout/utils/Header.vue";

export default {
  name: "StoreSetupForm",
  components: {
    Header,
    vSelect,
  },
  data() {
    return {
      selectedUser: null,
      users: [],
    };
  },
  computed: {
    loading() {
      return this.$store.getters.getLoadingState;
    },
    loadText() {
      return this.loading ? "Please Wait..." : "Save";
    },
  },
  async mounted() {
    this.fetchUsers();
  },
  methods: {
    async fetchUsers() {
      this.$utils.showLoading();
      try {
        const response = await axios.get(`${ticketApi}support/getActiveSupportStaff`);
        this.users = response.data;
      } catch (error) {
        console.error("Error fetching users:", error);
      } finally {
        this.$utils.hideLoading();
      }
    },
    async submit() {
      this.$utils.showLoading();
      try {
        const payload = {
          userID: this.selectedUser.id,
          storeDB: await this.getStoreDB(),
        };

        // Encrypt payload before storing
        const encryptedPayload = CryptoJS.AES.encrypt(
            JSON.stringify(payload),
            "your-secret-key"
        ).toString();

        localStorage.setItem("users", encryptedPayload);

        await axios.post(`${ticketApi}support/requestOTP`, payload);
        this.$router.push({ name: "OtpLogin" });
      } catch (error) {
        console.error("Error submitting form:", error);
      } finally {
        this.$utils.hideLoading();
      }
    },
    async getStoreDB() {
      let store = await Storage.getDefaultStore();
      return store.StoreDB;
    },
  },
};
</script>

<style scoped>
.btn {
  background: #1e88e5;
  color: white;
  font-weight: 600;
  display: block;
  width: 100%;
  height: 45px;
}

.card {
  padding-left: 10px;
  padding-right: 10px;
  width: 400px;
  max-width: 95vw;
  margin-top: -3rem !important;
}
.page{
  height: 100vh !important;
  overflow-y: auto;
}
.show-password-checkbox{
  margin-bottom: 20px;
}
</style>
